import { useCurrentLead } from '@/pages/registration/hooks/useCurrentLead';
import { lazy } from 'react';

import { PageLoader } from './PageLoader';

const Registration = lazy(() => import('../pages/registration/Registration'));
const Roulette = lazy(() => import('../pages/roulette/Roulette'));
const Prize = lazy(() => import('../pages/prize/Prize'));

export const Router = () => {
	const { data: currentLead, isFetched } = useCurrentLead();

	if (!isFetched || !currentLead?.status) return <PageLoader />;

	switch (currentLead.status) {
		case 'not-registered':
			return <Registration />;

		case 'no-prize':
			return <Roulette />;

		case 'registered-with-prize':
			return <Prize />;

		default:
			return null;
	}
};
